export const getContactTypeLabel = (type) => {
  switch (type) {
    case 'buyer':
      return 'Buyer';
    case 'seller':
      return 'Seller';
    case 'Buyer/Seller':
      return 'Buyer/Seller';
    case 'auction_house':
      return 'Auction House';
    default:
      return type;
  }
};

export const getContactTypeColor = (type) => {
  switch (type) {
    case 'buyer':
      return 'bg-green-100 text-green-800';
    case 'seller':
      return 'bg-blue-100 text-blue-800';
    case 'Buyer/Seller':
      return 'bg-purple-100 text-purple-800';
    case 'auction_house':
      return 'bg-amber-100 text-amber-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
